// @ts-nocheck

import palette from '../palette';

export const RealityCheckModal = {
  backgroundColor: palette.bluegrey850,
  closeButtonBackgroundColor: palette.bluegrey700,
};
